import { defineStore } from "pinia";
import { state } from "./state";
import { permissions_state, permissions_actions, permissions_getters } from "./permissions";
import { actions_mydrive } from "./actions_mydrive";
import { documentFunctions_state, documentFunctions_actions, documentFunctions_getters } from "./documentFunctions";
import {
  actions_confidentialdocuments,
  getters_confidentialdocuments,
  state_confidentialdocuments
} from "./confidentialDocuments";
import { templates_state, templates_actions, templates_getters } from "./templates";
import { driveItems_state, driveItems_actions, driveItems_getters } from "./driveItems";
import {
  driveItemsHierarchy_state,
  driveItemsHierarchy_actions,
  driveItemsHierarchy_getters
} from "./driveItemsHierarchy";
import { quickshare_actions, quickshare_getters, quickshare_state } from "./quickshare";
import { sensitivityLabels_actions, sensitivityLabels_getters, sensitivityLabels_state } from "./sensitivityLabels";
import { controlledArea_state, controlledArea_actions, controlledArea_getters } from "./controlledArea";
import { sharedDrives_state, sharedDrives_actions, sharedDrives_getters } from "./sharedDrives";
import { breadCrumb_state, breadCrumb_actions, breadCrumb_getters } from "./breadCrumb";
import { myFiles_state, myFiles_actions, myFiles_getters } from "./myFiles";
import { getters } from "./getters";

export const useDocumentStore = defineStore("documents", {
  state: () =>
    JSON.parse(
      JSON.stringify(
        Object.assign(
          {},
          state,
          permissions_state,
          state_confidentialdocuments,
          quickshare_state,
          sensitivityLabels_state,
          templates_state,
          driveItems_state,
          driveItemsHierarchy_state,
          documentFunctions_state,
          controlledArea_state,
          sharedDrives_state,
          breadCrumb_state,
          myFiles_state
        )
      )
    ),
  actions: Object.assign(
    {},
    permissions_actions,
    actions_mydrive,
    actions_confidentialdocuments,
    templates_actions,
    sensitivityLabels_actions,
    quickshare_actions,
    documentFunctions_actions,
    driveItems_actions,
    driveItemsHierarchy_actions,
    controlledArea_actions,
    sharedDrives_actions,
    breadCrumb_actions,
    myFiles_actions
  ),
  getters: Object.assign(
    {},
    getters,
    permissions_getters,
    getters_confidentialdocuments,
    templates_getters,
    driveItems_getters,
    driveItemsHierarchy_getters,
    quickshare_getters,
    sensitivityLabels_getters,
    documentFunctions_getters,
    controlledArea_getters,
    sharedDrives_getters,
    breadCrumb_getters,
    myFiles_getters
  )
});
